import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../../utils';
import { partnerApiPath } from '../../../apiPath';
import { partnerHttpClient } from '../../../httpClient';

const ProposalCampaignStatusSchema = z
  .enum(['ACTIVE', 'INACTIVE'])
  .describe('ProposalCampaignStatusSchema');

const GetProposalCampaignsCountRequestSchema = z
  .object({
    platform: z.string(),
    title: z.string().nullable().optional(),
    brandIds: z.array(z.string()).nullable().optional(),
    status: ProposalCampaignStatusSchema.nullable().optional(),
  })
  .describe('GetProposalCampaignsCountRequestSchema');

export type GetProposalCampaignsCountRequest = z.infer<
  typeof GetProposalCampaignsCountRequestSchema
>;

const GetProposalCampaignsCountResponseDataSchema = z
  .object({
    totalCount: z.number(),
  })
  .describe('GetProposalCampaignsCountResponseDataSchema');

const GetProposalCampaignsCountResponseSchema = createApiResponseSchema(
  GetProposalCampaignsCountResponseDataSchema,
);

export type GetProposalCampaignsCountResponse = z.infer<
  typeof GetProposalCampaignsCountResponseSchema
>;

export const getProposalCampaignsCount = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetProposalCampaignsCountRequestSchema),
    async (params: GetProposalCampaignsCountRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetProposalCampaignsCountResponse>(
          partnerApiPath.getProposalCampaignsCount,
          params,
        ),
      ),
    validateApiResponse(GetProposalCampaignsCountResponseSchema),
  ),
);
